import { Context } from '@nuxt/types'
import * as nuxtUtils from '@ustra/nuxt/src/utils/nuxt-utils'
import { findMenuByUrl } from '../models/menu/menu-model'
import loginService from '../services/login-service'

export default async (ctx: Context, _cb) => {
  await ctx.$ustra.hs.store.auth.loadUserInfo()
  await ctx.$ustra.hs.store.menuData.setCurrentProgramMenu(ctx.route.path)
  await ctx.$ustra.hs.store.menuData.addRecentMenu(ctx.route.path)

  // 메뉴 이력 추가
  const menu = findMenuByUrl(ctx.$ustra.hs.store.menuData.menus, ctx.route.path)
  if (menu) loginService.insertMenuHist(menu.menuId)

  // component로 부터 옵션을 조회한다.
  const option = nuxtUtils.getRouteOption(ctx.route)
  if (option && option.pageConfig) {
    ctx.app.pageConfig = ctx.$ustra.utils.core.deepMerge({}, option.pageConfig)
  } else {
    ctx.app.pageConfig = {}
  }
  _cb()
}
